import { render, staticRenderFns } from "./AlterarProcedimento.vue?vue&type=template&id=08cc3866&"
import script from "./AlterarProcedimento.vue?vue&type=script&lang=js&"
export * from "./AlterarProcedimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports